import { ApolloError } from '@apollo/client';
export function hasGraphQLErrorCode(error, targetCode) {
    return error.graphQLErrors.some((err) => { var _a; return ((_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code) === targetCode; });
}
export function graphQLErrorCode(error) {
    var _a, _b, _c;
    const foundError = error.graphQLErrors.find((err) => { var _a; return (_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code; }) ||
        error.graphQLErrors.find((err) => { var _a; return (_a = err.extensions) === null || _a === void 0 ? void 0 : _a.exception; });
    return (((_b = (_a = foundError === null || foundError === void 0 ? void 0 : foundError.extensions) === null || _a === void 0 ? void 0 : _a.exception) === null || _b === void 0 ? void 0 : _b.code) ||
        ((_c = foundError === null || foundError === void 0 ? void 0 : foundError.extensions) === null || _c === void 0 ? void 0 : _c.code) ||
        'UNKNOWN_ERROR');
}
export function graphQLErrorMessage(error) {
    if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
        return error.graphQLErrors.map((err) => (err === null || err === void 0 ? void 0 : err.message) || 'Unknown error');
    }
    return ['No GraphQL errors found'];
}
